// Static groups per tourId. Add an entry here for each tour that needs its own set.
const DEFAULT_GROUPS = [
  { label: "Race to Dubai", value: "388" },
  { label: "Opening Swing", value: "390" },
  { label: "International Swing", value: "391" },
  { label: "Asian Swing", value: "392" },
];

const TOUR_GROUPS: Record<string, { label: string; value: string }[]> = {
  default: DEFAULT_GROUPS,
  "1": DEFAULT_GROUPS,
  "2": [],
  "3": [{ label: "Road to Mallorca", value: "398" }],
};

const customFunctions = {
  fetchColorsFromTheme: function () {
    return [
      {
        label: "PRIMARY",
        id: "prelemType1",
        parentId: 0,
      },
      {
        label: "SECONDARY",
        id: "prelemType2",
        parentId: 0,
      },
      {
        label: "TERTIARY",
        id: "prelemType3",
        parentId: 0,
      },
    ];
  },
  fetchYears: function () {
    const endYear = new Date().getFullYear() + 1;
    return Array.from({ length: 6 }, (_, index) => {
      const year = endYear - index;
      return {
        label: String(year),
        id: year,
        parentId: 0,
      };
    });
  },
  // Returns the static groups/swings for the selected tour (brand). Falls back to the
  // default set when the tour has no entry of its own.
  fetchGroupsList: function () {
    const tourId = localStorage.getItem("selectedBrand") || "";
    return TOUR_GROUPS[tourId] || TOUR_GROUPS.default;
  },
};

export default customFunctions;
